import React from "react"
export function Refund(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M15.498 14.459A7.239 7.239 0 0110 16.978c-4.004 0-7.25-3.24-7.25-7.237 0-.34.023-.676.07-1.008h1.518A5.745 5.745 0 0010 15.48a5.738 5.738 0 004.102-1.717h-2.083v-1.498h4.229a.75.75 0 01.75.749v4.235h-1.5v-2.791zM5.879 5.736h2.6v1.498H4.825v.001h-.332l-.057-.001H4.25a.75.75 0 01-.75-.749V2.25H5v2.249a7.25 7.25 0 015-1.995c4.004 0 7.25 3.24 7.25 7.237 0 .349-.025.692-.073 1.028h-1.52A5.745 5.745 0 0010 4a5.752 5.752 0 00-4.12 1.736z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__refund"
        />
      </g>
    </svg>
  )
}
